import axios from 'axios';
import { useFetch } from "../useFetch";
import config from '../../../shared/services/config';

const OUTLET_API_ENPOINTS = {
  GET: '/filters/outlet',
  SEARCH: '/search/outlet'
}

export const useGetOutlets = ({ mid, authToken, ...restProps }) => {
  return useFetch({
    fetchFn: ({ pageNo, pageSize, outletId }) => axios({
      url: config.get('apiGatewayHostUrl') + OUTLET_API_ENPOINTS.GET,
      params: { offset: pageNo, size: pageSize },
      headers: { mid, Authorization: `Bearer ${authToken}`, ...(outletId ? { outlet: outletId } : {}) },
      method: 'get'
    }),
    ...restProps
  })
}

export const useSearcdhOutlets = ({ mid, authToken, ...restProps }) => {
  return useFetch({
    fetchFn: ({ pageNo, pageSize, searchTerm }) => axios({
      url: config.get('apiGatewayHostUrl') + OUTLET_API_ENPOINTS.SEARCH,
      params: { offset: pageNo, size: pageSize, name: searchTerm },
      headers: { mid, Authorization: `Bearer ${authToken}` },
      method: 'get'
    }),
    ...restProps
  })
}